import Vue from 'vue'
import App from './App.vue'
import './registerServiceWorker'

import UUID from 'vue-uuid'
import router from './router'
import store from './store'

import './assets/css/reset.css'
// katex使用時の表示制御css
import 'katex/dist/katex.min.css'

Vue.config.productionTip = false

Vue.use(UUID)

import http from './plugins/http'
Vue.use(http, router)

import Loading from './plugins/Loading'
Vue.use(Loading)

import Console from './plugins/Console'
Vue.use(Console)

import VueCookies from 'vue-cookies'
Vue.use(VueCookies)

import bcbtCookies from './plugins/bcbtCookies'
Vue.use(bcbtCookies)

import prevPage from './plugins/prevPage'
Vue.use(prevPage)

import convertString from './plugins/convertString'
Vue.use(convertString)

import webime from './plugins/webime'
Vue.use(webime)

import localDateFns from './plugins/localDateFns'
Vue.use(localDateFns)

import compress from './plugins/compress'
Vue.use(compress)

import VueHead from 'vue-head'
Vue.use(VueHead)

import VCalendar from 'v-calendar'
Vue.use(VCalendar)

import VModal from 'vue-js-modal'
Vue.use(VModal)

import Vue2Editor from 'vue2-editor'
Vue.use(Vue2Editor)

import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
Vue.component('fa-icon', FontAwesomeIcon)

import { library } from '@fortawesome/fontawesome-svg-core'
import { fas } from '@fortawesome/free-solid-svg-icons'
library.add(fas as any)

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app')
